import { competitionsB2CRApi } from 'entities/competitions-b2cr';
import { toast } from 'react-toastify';
import { ErrorMessageDataType } from 'shared/types';
import { prepareQueryArrayParam } from 'shared/utils';
import { BrandPlanList, GetBrandPlansParams } from '../types';

const getBrandPlansApi = competitionsB2CRApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrandPlansList: builder.query<BrandPlanList, GetBrandPlansParams>({
      query: ({ kpi_ids = [] }) => ({
        url: `/kpi-calendar/admin/brand_plans/${kpi_ids.length > 0 ? `?${prepareQueryArrayParam('kpi_ids', kpi_ids)}` : ''}`,
      }),
      providesTags: (result, error) => {
        const errorMessageStandart = 'Возникла ошибка при получении списка брендов.';
        const errorMessageNotFound = 'Бренды для соревнования не найдены.';
        if (error) {
          if (error.status === 500) {
            toast.error(errorMessageStandart.toString(), {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else if (error.status === 404) {
            toast.error(errorMessageNotFound.toString(), {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error((error.data as ErrorMessageDataType).detail, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        return ['BrandPlansList'];
      },
    }),
  }),
});

export const { useGetBrandPlansListQuery } = getBrandPlansApi;
